
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import GroupTitle from 'vux/src/components/group-title/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Qrcode from 'vux/src/components/qrcode/index.vue'

import Vue from 'vue';
import {
Icon
} from 'vant';

Vue.use(Icon)
import {
storage,
isEmptyString,
formateName,
getInfoFromIdcard,
idCardAge
} from "../js/common";
import {
encryptData
} from "../js/encrypt";
import api from "../js/api";
import http from "../js/http";

export default {
components: {
Grid,
GridItem,
Flexbox,
FlexboxItem,
GroupTitle,
TransferDom,
Actionsheet,
Qrcode
},
data() {
return {
show: false,
menus: {
menu1: "疫苗预约",
menu2: "预约记录",
menu1: "疫苗预约",
menu2: "预约记录",
},
showDialog: false,
tongzhiList: [],
shownIndex: 0,
patientList: [], // 就诊人列表
patientDefault: {},
showPList: false,
showQrcode: false,
right: '30',
bottom: '100',

isDragging: false,
startX: 0,
startY: 0,
currentX: 0,
currentY: 0,
startClientX: 0,
startClientY: 0,
hasMoved: false, // 新增：是否发生过移动

};
},









mounted() {
this.$nextTick(() => {
this.setInitialPosition();
});
},
created() {

this.getPatientList();
localStorage.removeItem("patient");
localStorage.removeItem("totalFee");
localStorage.removeItem("recipeSeqs");
localStorage.removeItem("payType");
},
methods: {




setInitialPosition() {
const img = this.$refs.draggableImg;
if (!img) return;
const rect = img.getBoundingClientRect();
this.currentX = window.innerWidth - rect.width - 30;
this.currentY = window.innerHeight - rect.height - 130;
img.style.transform = `translate(${this.currentX}px, ${this.currentY}px)`;
},

onTouchStart(e) {
const touch = e.touches[0];
this.startClientX = touch.clientX;
this.startClientY = touch.clientY;
this.startX = touch.clientX - this.currentX;
this.startY = touch.clientY - this.currentY;
this.hasMoved = false;
this.isDragging = false;
e.preventDefault();
},

onTouchMove(e) {
const touch = e.touches[0];
const dx = Math.abs(touch.clientX - this.startClientX);
const dy = Math.abs(touch.clientY - this.startClientY);

if (dx > 5 || dy > 5) {
this.hasMoved = true;
this.isDragging = true;
}

if (!this.isDragging) return;

let newX = touch.clientX - this.startX;
let newY = touch.clientY - this.startY;

const img = this.$refs.draggableImg;
const rect = img.getBoundingClientRect();
const vw = window.innerWidth;
const vh = window.innerHeight;

newX = Math.max(16, Math.min(newX, vw - rect.width - 16));
newY = Math.max(16, Math.min(newY, vh - rect.height - 16));

this.currentX = newX;
this.currentY = newY;
img.style.transform = `translate(${newX}px, ${newY}px)`;

e.preventDefault();
},

onTouchEnd() {

if (!this.hasMoved) {
this.goTo();
}
this.isDragging = false;
},
onClickFallback(e) {



if (!this.hasMoved) {
this.goTo();
}
},
goTo() {
if (this.patientList.length < 1) {
this.$vux.toast.text("请添加就诊人", "middle");
return
}
let user = this.patientDefault;
let gender = getInfoFromIdcard(user.certNo).gender
let age = idCardAge(user.certNo)
let query = {
userName: user.userName,
phone: user.mobile,
medicalCardNum: user.cardNo,
openid: user.uniqueCode,
age: age,
gender: gender,
};
let params = encryptData(query).urlEncoded
console.log(params)

location.href = "https://www.yldmxai.cn/big-model-h5/intelligent-guidance?identityType=zkrmyy&params=" +
params



},
/**
* 获取绑定患者列表
*/
getPatientList() {
let query = {
uniqueCode: storage.getSessionstorage("openid"),
};
this.patientList = [];
http.get(api.userList, query, true).then((res) => {
let data = res.data;
if (data.status == "true" || data.status == true) {
let patientList = data.data || [];
let patientDefault = {}
if (patientList.length > 0) {
for (let i = 0; i < patientList.length; i++) {
const patient = patientList[i]
patient.userNamePw = formateName(patient.userName);
if (patient.isDefault == 1) {
patientDefault = patient
}
}

}
this.patientList = patientList;
this.patientDefault = patientDefault;
} else {}
});
},

checkPatient(item) {
if (this.patientDefault.cardNo != item.cardNo) {
let query = {
uniqueCode: storage.getSessionstorage("openid"),
id: item.id,
};
http.post(api.setDefaultUser, query).then((res) => {
let data = res.data;
if (data.status == true || data.status == "true") {
this.showPList = false;
this.getPatientList();
} else {
this.$vux.toast.show({
type: "warn",
text: "切换默认就诊人失败",
width: "9.6em",
});
}
});
} else {
this.showPList = false;
}
},
getNoticeList() {
http
.get(api.getArticleList, {
id: "978b90f0393a441c9beba964eccb9450",
currentPageInt: 0,
pageSize: 20,
})
.then((res) => {
const data = res.data;
if (data.status) {
this.tongzhiList = data.data;
this.initScroll();
}
});
},
initScroll() {
setInterval(() => {
if (this.shownIndex >= this.tongzhiList.length - 1) {
this.shownIndex = 0;
} else {
this.shownIndex++;
}
}, 3000);
},
toNoticeListPage() {
this.$router.push({
path: "/noticedetail",
});






},
/**
* 挂号页面跳转
* path: 路由
*/
onRegisterClick(type) {
this.$store.commit("updateRegisterWay", type);
this.$router.push({
path: '/chooseDepartment',
});
},

reportTips(path) {
let _this = this;
this.$vux.confirm.show({
title: "提示",
content: `本信息为个人敏感信息，请确认本人自愿查看，并妥善保管`,


confirmText: "取消",
cancelText: "确认",
onCancel() {

_this.onClick(path);
},
onConfirm() {

},
});
},
onClick(path) {
this.$router.push({
path: path,
});
},
toHos() {
let time = Number(this.getNowTime().replace(":", ""));


if (time > 600 && time < 2300) {
this.$router.push({
path: "/hospitalizationSearch/1",
});
} else {
this.$vux.toast.text("系统维护中！", "middle");
}
},
getNowTime() {
let now = new Date();
let hour = now.getHours(); 
let minute = now.getMinutes(); 
let nowTime = "";
nowTime = this.fillZero(hour) + ":" + this.fillZero(minute);
return nowTime;
},

fillZero(str) {
var realNum;
if (str < 10) {
realNum = "0" + str;
} else {
realNum = str;
}
return realNum;
},
noCompeled(path) {
this.$router.push({
path: path,
query: {
identifying: "2",
},
});
},
/*
就诊卡充值
*/
onAccountChargeClick() {
this.$router.push("/accountChargeWx");
},
noOpen() {
this.$vux.toast.text("服务升级中", "middle");
},
},
};



// WEBPACK FOOTER //
// ./src/components/index.vue